/* Progress bar */
(function () {
  const goal = 99;
  let initialized = false;

  function getPrice() {
    const priceText = document.querySelector('.cart_subtotal')?.textContent || "₪0";
    return parseFloat(priceText.replace(/[^\d.]/g, "")) || 0;
  }

  function getItemCount() {
    // אם יש לך אלמנט שמציג את מספר הפריטים בעגלה - למשל .cart_count
    const itemCountText = document.querySelector('.cart_count')?.textContent || "0";
    return parseInt(itemCountText.replace(/[^\d]/g, ""), 10) || 0;
  }

  function renderProgressBar() {
    const current = getPrice();
    const items = getItemCount();
    const remaining = Math.max(goal - current, 0);

    // אם אין מוצרים → אחוז = 0
    const percent = items === 0 ? 0 : Math.min((current / goal) * 100, 100);

    const target = document.getElementById('mini-cart-shippingbar');
    if (!target) return;

    let wrapper = document.getElementById("progress-wrapper");

    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.id = "progress-wrapper";
      wrapper.style.margin = "0";

      // אלמנט לכמות מוצרים
      const itemCountEl = document.createElement("div");
      itemCountEl.id = "cart-item-count";
      itemCountEl.style.textAlign = "left";

      // אלמנט לטקסט ההודעה
      const message = document.createElement("div");
      message.id = "shipping-message";
      message.style.marginBottom = "16px";
      message.style.lineHeight = "14px";
      message.style.textAlign = "left";

      const barContainer = document.createElement("div");
      barContainer.style.backgroundColor = "#eee";
      barContainer.style.borderRadius = "20px";
      barContainer.style.border = "1px solid #012939";
      barContainer.style.height = "14px";
      barContainer.style.position = "relative";

      const bar = document.createElement("div");
      bar.className = "gift-bar";
      bar.style.backgroundColor = "#012939";
      bar.style.height = "100%";
      bar.style.borderRadius = "20px";
      bar.style.transition = "width 0.3s";

      barContainer.appendChild(bar);
      wrapper.appendChild(itemCountEl);
      wrapper.appendChild(message);
      wrapper.appendChild(barContainer);

      target.parentElement.insertBefore(wrapper, target);
    }

    // עדכון כמות מוצרים
    const itemCountEl = wrapper.querySelector("#cart-item-count");
    if (items > 0) {
      itemCountEl.innerHTML = `${items} item${items > 1 ? "s" : ""}`;
    } else {
      itemCountEl.innerHTML = `You are $${remaining.toFixed(2)} away from <span style="font-weight:600;">FREE</span> shipping`;
    }

    // עדכון טקסט משלוח
    const message = wrapper.querySelector("#shipping-message");
    if (items === 0) {
      message.innerHTML  = "";
    } else if (remaining > 0) {
      message.innerHTML = `You are $${remaining.toFixed(2)} away from <span style="font-weight:600;">FREE</span> shipping`;
    } else {
      message.innerHTML = `Free standard shipping unlocked`;
    }

    // עדכון פרוגרס בר
    const bar = wrapper.querySelector(".gift-bar");
    if (bar) bar.style.width = `${percent}%`;
  }

  function observeCartSubtotal() {
    if (initialized) return; // למנוע כפילות
    initialized = true;

    const subtotalEl = document.querySelector('.cart_subtotal');
    if (!subtotalEl) return;

    console.log("✅ התחברנו ל־.cart_subtotal");

    let timeout;
    const priceObserver = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        renderProgressBar();
      }, 100);
    });

    priceObserver.observe(subtotalEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.cart_subtotal')) {
      observeCartSubtotal();
      renderProgressBar();
    }
  });

  // --- 🎯 AJAX Hook ל־fetch ---
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    if (args[0].toString().includes("/cart")) {
      setTimeout(renderProgressBar, 200);
    }
    return response;
  };

  // --- 🎯 AJAX Hook ל־XMLHttpRequest ---
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.addEventListener("load", function () {
      if (url.includes("/cart")) {
        setTimeout(renderProgressBar, 200);
      }
    });
    return origOpen.call(this, method, url, ...rest);
  };
})();

 /* END Progress bar */



/* Toggle ingredients */

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
document.querySelectorAll('.ingredient-title').forEach(title => {
  title.addEventListener('click', function() {
    const desc = this.parentElement.querySelector('.ingredient-desc');
    const icon = this.querySelector('.toggle-icon');

    if (desc.style.display === "block") {
      desc.style.display = "none";
      icon.classList.remove("open");
    } else {
      desc.style.display = "block";
      icon.classList.add("open");
    }
  });
});
  }

  /*const section = document.querySelector(".product-all-ingredients");  
  const title = section.querySelector(".product-all-ingredients-title");

  title.addEventListener("click", function() {
    section.classList.toggle("closed");
  });*/
});


/* END Toggle ingredients */

$('.how-to-use-tab').on('click', function(){
  $('.how-to-use-content').slideToggle();
  $('.how-to-use-tab span').html($('.how-to-use-tab span').html() == '-' ? '+' : '-');
});

/*$('.ingredients-tab').on('click', function(){
  $('.ingredients-content').slideToggle();
  $('.ingredients-tab span').html($('.ingredients-tab span').html() == '-' ? '+' : '-');
});*/

$('.read-more').on('click', function(){
	$('.read-more-content').slideToggle();
  	$('.read-more').html($('.read-more').html() == 'Read more' ? 'Read less' : 'Read more');
});

$('.read-more2').on('click', function(){
	$('.read-more-content2').slideToggle();
});

$(".what-and-how-set-tab1").on('click', function(){
  $('.image-with-text-container1').css("display", "flex");
  $('.image-with-text-container2').hide();
  $('.image-with-text-container3').hide();
  $('.image-with-text-container4').hide();
});

$(".what-and-how-set-tab2").on('click', function(){
  $('.image-with-text-container1').hide();
  $('.image-with-text-container2').css("display", "flex");
  $('.image-with-text-container3').hide();
  $('.image-with-text-container4').hide();
});

$(".what-and-how-set-tab3").on('click', function(){
  $('.image-with-text-container1').hide();
  $('.image-with-text-container2').hide();
  $('.image-with-text-container3').css("display", "flex");
  $('.image-with-text-container4').hide();
});

$(".what-and-how-set-tab4").on('click', function(){
  $('.image-with-text-container1').hide();
  $('.image-with-text-container2').hide();
  $('.image-with-text-container3').hide();
  $('.image-with-text-container4').css("display", "flex");
});


$(".what-and-how-set-tab").on('click', function(){
  $(".what-and-how-set-tab").removeClass('active');
  $(this).addClass('active');
});


/* c me step 2 FAQ */

$('.step2-q1').on('click', function(){
	$('.step2-a1').slideToggle();
});
$('.step2-q2').on('click', function(){
	$('.step2-a2').slideToggle();
});
$('.step2-q3').on('click', function(){
	$('.step2-a3').slideToggle();
});
$('.step2-q4').on('click', function(){
	$('.step2-a4').slideToggle();
});
$('.step2-q5').on('click', function(){
	$('.step2-a5').slideToggle();
});


/* solution page */
$('.argania-tab1').on('click', function(){
	$('.argania-content1').slideToggle();
});
$('.argania-tab2').on('click', function(){
	$('.argania-content2').slideToggle();
});
$('.argania-tab3').on('click', function(){
	$('.argania-content3').slideToggle();
});
$('.argania-tab4').on('click', function(){
	$('.argania-content4').slideToggle();
});

$('.spf_q1').on('click', function(){
	$('.spf_a1').slideToggle();
});
$('.spf_q2').on('click', function(){
	$('.spf_a2').slideToggle();
});
$('.spf_q3').on('click', function(){
	$('.spf_a3').slideToggle();
});
$('.spf_q4').on('click', function(){
	$('.spf_a4').slideToggle();
});
$('.spf_q5').on('click', function(){
	$('.spf_a5').slideToggle();
});


$('.comprehensive-tab1').on('click', function(){
	$('.comprehensive-content1').slideToggle();
});
$('.comprehensive-tab2').on('click', function(){
	$('.comprehensive-content2').slideToggle();
});
$('.comprehensive-tab3').on('click', function(){
	$('.comprehensive-content3').slideToggle();
});

$('.formulated-tab1').on('click', function(){
	$('.formulated-content1').slideToggle();
});

$('.runners-face-tab1').on('click', function(){
	$('.runners-face-content1').slideToggle();
});
$('.runners-face-tab2').on('click', function(){
	$('.runners-face-content2').slideToggle();
});
$('.runners-face-tab3').on('click', function(){
	$('.runners-face-content3').slideToggle();
});
$('.runners-face-tab4').on('click', function(){
	$('.runners-face-content4').slideToggle();
});
$('.runners-face-tab5').on('click', function(){
	$('.runners-face-content5').slideToggle();
});
$('.runners-face-tab6').on('click', function(){
	$('.runners-face-content6').slideToggle();
});
$('.runners-face-tab7').on('click', function(){
	$('.runners-face-content7').slideToggle();
});

$('.detail-tab1').on('click', function(){
	$('.detail-content1').slideToggle();
});

$('.detail-tab2').on('click', function(){
	$('.detail-content2').slideToggle();
}); 

$('.detail-tab3').on('click', function(){
	$('.detail-content3').slideToggle();
}); 

   $(document).ready(function(){
        $(".argania-tab1").click(function(){
            $('.argania-tab1 span').html($('.argania-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab2").click(function(){
            $('.argania-tab2 span').html($('.argania-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab3").click(function(){
            $('.argania-tab3 span').html($('.argania-tab3 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab4").click(function(){
            $('.argania-tab4 span').html($('.argania-tab4 span').html() == '+' ? '-' : '+');
        });

        $(".spf_q1").click(function(){
            $('.spf_q1 span').html($('.spf_q1 span').html() == '+' ? '-' : '+');
        });
        $(".spf_q2").click(function(){
            $('.spf_q2 span').html($('.spf_q2 span').html() == '+' ? '-' : '+');
        });
        $(".spf_q3").click(function(){
            $('.spf_q3 span').html($('.spf_q3 span').html() == '+' ? '-' : '+');
        });
        $(".spf_q4").click(function(){
            $('.spf_q4 span').html($('.spf_q4 span').html() == '+' ? '-' : '+');
        });
        $(".spf_q5").click(function(){
            $('.spf_q5 span').html($('.spf_q5 span').html() == '+' ? '-' : '+');
        });

     $(".step2-q1").click(function(){
            $('.step2-q1 span').html($('.step2-q1 span').html() == '+' ? '-' : '+');
        });
        $(".step2-q2").click(function(){
            $('.step2-q2 span').html($('.step2-q2 span').html() == '+' ? '-' : '+');
        });
        $(".step2-q3").click(function(){
            $('.step2-q3 span').html($('.step2-q3 span').html() == '+' ? '-' : '+');
        });
     
        $(".comprehensive-tab1").click(function(){
            $('.comprehensive-tab1 span').html($('.comprehensive-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".comprehensive-tab2").click(function(){
            $('.comprehensive-tab2 span').html($('.comprehensive-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".comprehensive-tab3").click(function(){
            $('.comprehensive-tab3 span').html($('.comprehensive-tab3 span').html() == '+' ? '-' : '+');
        });
     
         $(".formulated-tab1").click(function(){
            $('.formulated-tab1 span').html($('.formulated-tab1 span').html() == '+' ? '-' : '+');
        }); 
     
     	$(".runners-face-tab1").click(function(){
            $('.runners-face-tab1 span').html($('.runners-face-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab2").click(function(){
            $('.runners-face-tab2 span').html($('.runners-face-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab3").click(function(){
            $('.runners-face-tab3 span').html($('.runners-face-tab3 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab4").click(function(){
            $('.runners-face-tab4 span').html($('.runners-face-tab4 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab5").click(function(){
            $('.runners-face-tab5 span').html($('.runners-face-tab5 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab6").click(function(){
            $('.runners-face-tab6 span').html($('.runners-face-tab6 span').html() == '+' ? '-' : '+');
        });
     	$(".runners-face-tab7").click(function(){
            $('.runners-face-tab7 span').html($('.runners-face-tab7 span').html() == '+' ? '-' : '+');
        });

        $(".detail-tab1").click(function(){
            $('.detail-tab1 span').html($('.detail-tab1 span').html() == '+' ? '-' : '+');
        });

        $(".detail-tab2").click(function(){
            $('.detail-tab2 span').html($('.detail-tab2 span').html() == '+' ? '-' : '+');
        });

       $(".detail-tab3").click(function(){
            $('.detail-tab3 span').html($('.detail-tab3 span').html() == '+' ? '-' : '+');
        });
     
        //$(".sidebar-block__heading").click(function(){
        //    $(this).find("span").html($(this).find("span").html() == '+' ? '-' : '+');
        //});
    });

$(document).on('click', '.select-shade-btn', function(event) {
  event.preventDefault();

  const $form = $(this).closest('.product_form');
  if (!$form.length) return;

  $form.find('.collection_swatch_options')
    .stop(true, true)
    .slideDown();

  $form.find('.select-shade-btn').hide();
});

$(document).on(
  'click',
  '.inline-quickshop-close-variants-mobile',
  function(event) {
    event.preventDefault();

    const $form = $(this).closest('.product_form');
    if (!$form.length) return;

    $form.find('.collection_swatch_options')
      .stop(true, true)
      .slideUp();

    $form.find('.select-shade-btn').show();
  }
);

$('.collection-filter-link').on('click', function(){
  $('.notsidebar-background').show();
  $('.sidebar').toggle( "slide" );
});

$(".mobile-filter-btn").on("click", function(){
	$(".sidebar").slideDown();
});

$('.collection-filter-close').on("click", function(){
    $('.notsidebar-background').hide();
	$('.sidebar').toggle( "slide" );
});

$('.notsidebar-background').on("click", function(){
    $('.notsidebar-background').hide();
	$('.sidebar').toggle( "slide" );
});

/* Sticky manu */

if ($(window).width() > 798) {
      if ($('.header').hasClass('header-fixed--true')){
        if (!$('.main-nav__wrapper').hasClass('sticky_nav')) {
          $( window ).scroll(function() {
            if ($(this).scrollTop() > 250) {
            //$( ".sticky_nav--stick .header__logo" ).hide();
            $( ".sticky_login" ).show();
            $( ".sticky_search" ).show();
            $( ".sticky_try-here-btn" ).show();
            $( ".sticky_try-here2-btn" ).show();
            $( ".sticky_logo" ).show();
            $( ".menu" ).addClass('sticky_menu')
            $( ".sticky_login" ).addClass('sticky_login-align');
            $( ".top-bar__menu .main-header-cart-container .mini_cart" ).addClass('sticky_cart-align');
            }
            if($(this).scrollTop() < 250){
              //$( ".sticky_nav--stick .header__logo" ).show();
              $( ".sticky_login" ).hide();
              $( ".sticky_search" ).hide();
              $( ".sticky_try-here-btn" ).hide();
              $( ".sticky_try-here2-btn" ).hide();
              $( ".sticky_logo" ).hide();
              $( ".menu" ).removeClass('sticky_menu');
              $( ".sticky_login" ).removeClass('sticky_login-align');
              $( ".top-bar__menu .main-header-cart-container .mini_cart" ).removeClass('sticky_cart-align');
            }
          });
        }
      }
    }

/* END Sticky menu */

/* SEE THE DIFFERENCE SECTION */

let slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("mySlides");
  let dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  if(slides[slideIndex-1]){
    
  slides[slideIndex-1].style.display = "block";
  dots[slideIndex-1].className += " active";
  }
}

/* END SEE THE DIFFERENCE SECTION */

$(".newsletter-landing-page-btn input").on('click', function(){

      if(!$('.newsletter-agree-checkbox-btn').is(":checked")){
              $('.errors2').html('You must agree');
            }
});
